import { useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import LoadingLottie from '../components/atoms/LoadingLottie';
import useGetParams from '../hooks/useGetParams';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import {
  useGetEventOrdersReportQuery,
  useGetEventSummaryPDFMutation,
} from '../store';
import AdminSectionTitle from '../components/AdminSectionTitle';
import HorizontalTabs from '../components/atoms/HorizontalTabs';
import PaymentsDetailsTable from '../components/PaymentsDetailsTable';
import AssistanceReportTab from '../components/AssistanceReportTab';
import SellersReportTab from '../components/SellersReportTab';
import GeneralReportTab from '../components/GeneralReportTab';

const EventSalesReportPage: React.FC = () => {
  const { eventId, businessId } = useGetParams();
  const { event } = useGetSelectedEvent();
  const { data: reportData, isLoading } = useGetEventOrdersReportQuery({
    businessId,
    eventId,
  });
  const [getEventSummaryPDF, { isLoading: isGeneratingReport }] = useGetEventSummaryPDFMutation();
  const [tab, setTab] = useState<'general' | 'details' | 'assistance' | 'sellers'>('general');

  if (isLoading) {
    return <LoadingLottie />;
  }
  if (!reportData) {
    return <div>No hay datos</div>;
  }

  return (
    <div className="flex flex-col gap-8 my-6 w-full">
      <AdminSectionTitle
        title={'Eventos'}
        subtitle={`${event?.name} - Reportes`}
        mainButtons={[
          {
            label: 'Descargar reporte de asistencia',
            onClick: () => getEventSummaryPDF({ businessId, eventId }),
            variant: 'secondary',
            icon: <FiDownload className='text-xl' />,
            loading: isGeneratingReport,
          },
        ]}
      />
      <div className='glass-surface px-3 pb-2 pt-1'>
        <HorizontalTabs
          tabs={[
            {
              label: 'Datos generales',
              onClick: () => setTab('general'),
              selected: tab === 'general',
            },
            {
              label: 'Detalles de pagos',
              onClick: () => setTab('details'),
              selected: tab === 'details',
            },
            {
              label: 'Tickets y asistencia',
              onClick: () => setTab('assistance'),
              selected: tab === 'assistance',
            },
            {
              label: 'Vendedores',
              onClick: () => setTab('sellers'),
              selected: tab === 'sellers',
            },
          ]}
        />
      </div>
      {tab === 'general' && (
        <GeneralReportTab event={event} />
      )}
      {tab === 'details' && (
        <div>
          <PaymentsDetailsTable />
        </div>
      )}
      {tab === 'assistance' && (
        <AssistanceReportTab event={event} />
      )}
      {tab === 'sellers' && (
        <SellersReportTab event={event} />
      )}
    </div >
  );
};

export default EventSalesReportPage;
